import { VodafoneTariffState } from '@tymbe/schema/enums';
import { VodafoneTariffTable } from './components/VodafoneTariffTable';

export const paidVodafoneTariffQueryId = 'admin/vodafoneTariff/paid';

export const PaidTab = () => {
  return (
    <VodafoneTariffTable
      queryId={paidVodafoneTariffQueryId}
      state={VodafoneTariffState.PAYMENT_SUCCESS}
      tabName="paid"
    />
  );
};
